<template>
  <div>
    <v-card>
      <v-card-title>
        ثبت سفارش
        <v-spacer />
        <v-btn color="error" @click="closeForm()" icon>
          <v-icon>mdi mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>

      <trade-request-form ref="TradeRequestForm"></trade-request-form>
    </v-card>
  </div>
</template>

<script>
import TradeRequestForm from '@/modules/tradeRequests/components/TradeRequestForm.vue';
import Swal from 'sweetalert2';
export default {
  data() {
    return {
      backButtonPrevented:false,
    };
  },
  components: {
    TradeRequestForm,
  },
  mounted(){
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', this.popStateListener);
  },
  destroyed(){
    this.backButtonPrevented = true;
    this.popStateListener();
  },
  methods: {
    popStateListener(event) {
  if (this.backButtonPrevented === false){
    history.pushState(null, document.title, location.href);
  Swal.fire({
        html: `شما در حال ترک عملیات نا تمام هستید و اطلاعات ثبت شده از بین خواهد رفت. آیا مطمئن به ترک این بخش بدون اتمام عملیات هستید؟`,
        icon: 'warning',
        confirmButtonText: ' بلی',
        showCancelButton: true,
        cancelButtonText: 'خیر',
        reverseButtons: true,
      }).then((result) => {
        if(result.value){
          window.removeEventListener('popstate', this.popStateListener);
         this.closeForm();
        }
        
      });
  } else {
      window.removeEventListener('popstate', this.popStateListener);
  }
},
    closeForm() {
      this.$store.commit('setTradeRequestSelectedForDisplay', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.$store.commit('setTradeRequestItems', []);
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setAllTradeRequests', []);
      this.$store.commit('setTradeRequestEditMode', false);
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestShowDetailForm', false);
      this.$store.commit('setTradeRequestSelectedForEdit', null);
      this.$router.push({ path: '/trade-request' });
    },
    showDetailForm() {
      this.$store.commit('setTradeRequestSelectedForDisplay', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.$store.commit('setTradeRequestItems', []);
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setAllTradeRequests', []);
      this.$store.commit('setTradeRequestFormStatus', false);
      this.$store.commit('setTradeRequestEditMode', false);
      /////////
      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestShowDetailForm', true);
      this.$store.commit('setTradeRequestSelectedForEdit', null);
    },
    createNewItem() {
      this.$store.commit('setTradeRequestSelectedForDisplay', null);
      this.$store.commit('setTradeRequestSingleItemForEdit', null);
      this.$store.commit('setTradeRequestItems', []);
      this.$store.commit('setTradeRequestSingleItem', null);
      this.$store.commit('setAllTradeRequests', []);
      this.$store.commit('setTradeRequestEditMode', false);
      ///////
      this.$store.commit('setTradeRequestFormStatus', true);

      this.$store.commit('setTradeRequestIsEdit', false);
      this.$store.commit('setTradeRequestShowDetailForm', false);
      this.$store.commit('setTradeRequestSelectedForEdit', null);
    },
  },
};
</script>

<style></style>
